import Layout from "../parts/Layout";
import VisitsPickerView from "../parts/main-page/VisitsPickerView";

export default function VisitPage() {
    return (
        <Layout>
            <VisitsPickerView/>
        </Layout>
    );
}